import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import styles from "./ToolCard.module.css";
function ToolCard({ name, iconSrc, iconAlt, description, reference }) {
    const [ref, , fadedClassName] = useIntersectionObserver(0.2);
    return (
        <div
            className={[styles.tool_card, fadedClassName].join(" ")}
            ref={(el) => {
                ref.current = el;
                if (reference) reference.current = el;
            }}
        >
            <img src={iconSrc} alt={iconAlt} />
            <div className={styles.bottom}>
                <strong>{name}</strong>
                <p>{description}</p>
            </div>
        </div>
    );
}

export default ToolCard;
